import template from './youtube.html';
import controller from './youtube.controller';
import './youtube.scss';

let youtubeComponent = {
  restrict: 'E',
  bindings: {videos: '<'},
  template,
  controller
};

export default youtubeComponent;



// WEBPACK FOOTER //
// ./client/app/components/apps/youtube/youtube.component.js